// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3N7E-","noMargin":"styles_noMargin__2MeC0"};